import React, { useState, useMemo } from 'react';
import MarkingCriteriaCard from '../MarkingCriteriaCard';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Toast from '../../Toast';
import { FeedbackToolWrapper } from '../../Shared/FeedbackTool';
import ImprovedSecondarySideBar from '../../ImprovedSecondarySideBar';
import MenuButton from '../../MenuButton';
import { isTabletView } from '../../ReactiveRender';
import PreviewDialog from '../../Shared/Dialogs/preview/previewCard';
import {
  importJsonFile,
  validateRubric,
} from '../../../components2/markingCriteria';
import { createNewMarkingCriteria } from '../../../service';
import Rubricsnew from '../../../static/img/Rubricsnew.svg';
import { PopUpCard, PopUpCardImg, PopUpCardText } from '../../Shared/FeedbackTool/style';

function AccountSettingsMarkingCriteriaDeskt({
  filteredAndSortedMarkingCriterias,
  resetMarkingCriterias,
  handleFilterSystemOnes,
  selectedCriteria,
  setSelectedCriteria,
  handleSelectAll,
  currentDatasetName,
  allMarkingCriteria,
  userPreferences,
  isLoading,
  onReorderMarkingCriteria,
  updateMarkingCriteriaPreferences,
  isOnlyMineFilter = false,
  isSystemFilterApplied = false,
  filteredCriteriasCount = 0,
  showHidden = false,
  setShowHidden = () => {},
  showOnlyMineFilter = false,
  setShowOnlyMineFilter = () => {},
  createMarkingCriteria,
  handleSelectCriteria
}) {
  const [isShowExportMarkingCriteriaPopup, setIsShowExportMarkingCriteriaPopup] = useState(false);
  const [importedMarkingCriteria, setImportedMarkingCriteria] = useState({});

  const tabletView = isTabletView();
  const history = useHistory();

  const hasActiveFilters = useMemo(() => {
    return (
      isOnlyMineFilter ||
      showHidden
    );
  }, [isOnlyMineFilter, showHidden]);



  const isDragDisabled = hasActiveFilters || isLoading

  const handleMarkingCriteriaImport = async (event) => {
    try {
      const importedJsonFile = await importJsonFile(event, ['mc']);
      setImportedMarkingCriteria(importedJsonFile);
      setIsShowExportMarkingCriteriaPopup(true);
    } catch (err) {
      console.error('Error importing marking criteria:', err);
    }
  };

  const getMarkingCriteriaId = (response) => response?.id?.value ?? response?.id;

  const handleCreateMarkingCriteria = (markingCriterias) => {
    if (!validateRubric(markingCriterias)) {
      toast(<Toast message={'Rubrics are not valid'} />);
      return;
    }
    createNewMarkingCriteria(markingCriterias).then((response) => {
      const id = getMarkingCriteriaId(response);
      if (id) {
        toast(<Toast message={'New Rubric created'} />);
        history.push(`/tools/rubrics/${id}`);
      } else {
        toast(<Toast message={'Created but failed to open. Refresh the page.'} />);
      }
    }).catch(() => toast(<Toast message={'Failed to create'} />));
    setIsShowExportMarkingCriteriaPopup(false);
  };



  const renderCreateOptions = () => (
    <PopUpCard onClick={() => history.push('/tools/rubrics/new')}>
      <PopUpCardImg src={Rubricsnew} />
      <PopUpCardText>Rubric</PopUpCardText>
    </PopUpCard>
  );

  const renderImportDialog = () => {
    if (isShowExportMarkingCriteriaPopup) {
      return (
        <PreviewDialog
          setMarkingCriteriaPreviewDialog={setIsShowExportMarkingCriteriaPopup}
          markingCriterias={importedMarkingCriteria}
          showActionButton={true}
          onActionButtonClick={handleCreateMarkingCriteria}
        />
      );
    }
    return null;
  };

  const renderItem = (element) => {
    if (element && typeof element === 'object' && element.id) {
      return (
        <MarkingCriteriaCard
          key={element.id}
          markingCriteria={element}
          cloneMarkingCriteria={() => createMarkingCriteria(element)}
          isSelected={selectedCriteria.has(element.id)}
          onSelect={() => handleSelectCriteria(element.id)}
          showCheckbox
        />
      );
    }
    
    return null;
  };

  return (
    <FeedbackToolWrapper
      enableReactQuery={true}
      context="markingCriteria"
      selectedItems={selectedCriteria}
      setSelectedCriteria={setSelectedCriteria}
      onImport={handleMarkingCriteriaImport}
      onSelectAll={handleSelectAll}
      renderItem={renderItem}
      renderCreateOptions={renderCreateOptions}
      renderImportDialog={renderImportDialog}
      isDragDisabled={isDragDisabled}
      hasActiveFilters={hasActiveFilters}
      tabletView={tabletView}
      MenuButton={MenuButton}
      SecondarySidebar={ImprovedSecondarySideBar}
      showHidden={showHidden}
      setShowHidden={setShowHidden}
      showOnlyMineFilter={showOnlyMineFilter}
      setShowOnlyMineFilter={setShowOnlyMineFilter}
      allMarkingCriteria={allMarkingCriteria}
    />
  );
}

export default AccountSettingsMarkingCriteriaDeskt;
